<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 50px">
        <el-date-picker v-fixZoom
          :clearable="false"
          v-model="logDate"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2"
          value-format="yyyy-MM-dd"
          style="margin-right: 10px; width: 400px">
        </el-date-picker>
        <el-button type="primary" @click="getLogData()">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto;">
        <el-table
          :data="showTable"
          border
          style="width: 100%;margin-top: 10px"
          highlight-current-row>
          <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
          <el-table-column prop="operator" label="操作账号" min-width="100" align="center"></el-table-column>
          <el-table-column prop="personname" label="操作人姓名" min-width="90" align="center"></el-table-column>
          <el-table-column label="导出类型" min-width="90" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.export_type === 1" type="info" size="small">普通导出</el-tag>
              <el-tag v-else-if="scope.row.export_type === 2" type="warning" size="small">扩展字段导出</el-tag>
              <span v-else>{{ scope.row.export_type }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="export_cnt" label="导出条数" min-width="80" align="center"></el-table-column>
          <el-table-column prop="filter_desc" label="筛选条件" min-width="120" align="center"></el-table-column>
          <el-table-column label="IP地址" min-width="110" align="center">
            <template slot-scope="scope">
              <span>{{ numberToIp(scope.row.ip) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="导出时间" min-width="140" align="center"></el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {queryexportlog} from '../../api/log'

export default {
  name: 'exportLog',
  data () {
    return {
      logDate: [],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0
    }
  },
  created () {
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd')
    this.logDate = [date, date]
    this.getLogData()
  },
  methods: {
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1)
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + m)
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions2.shortcuts = arrTime
    },
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getLogData () {
      let data = {
        from: this.logDate[0] + ' 00:00:00',
        to: this.logDate[1] + ' 23:59:59',
        page: this.currentPage,
        size: this.pageSize
      }
      queryexportlog(data).then(res => {
        this.showTable = res.data.exportlogs || []
        this.totalCells = res.data.cnt || 0
      }).catch(() => {})
    },
    numberToIp (number) {
      if (!number || number <= 0) return ''
      const ip3 = (number << 0) >>> 24
      const ip2 = (number << 8) >>> 24
      const ip1 = (number << 16) >>> 24
      const ip0 = (number << 24) >>> 24
      return ip3 + '.' + ip2 + '.' + ip1 + '.' + ip0
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getLogData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getLogData()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/systemlog/exportLog.vue